<template>
  <div class="i-pwd">
    <div class="up">
      <!-- 修改密码 -->
      <div class="facab">
        <div class="oText">{{ $t('main.ChangePassword') }}</div>
      </div>
    </div>
    <div class="down">
      <!-- 中文用手机号，英文用邮箱 -->
      <div>
        <el-form ref="form" :model="form" label-width="140px">
          <el-form-item
              class="is-required"
              :label="$t('main.OldPassword')"
              prop="old_psd"
          >
            <el-input
              v-model="form.old_psd"
              @keyup.enter.native="changePassword"
              :placeholder="$t('main.pleaseEnterYourPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.NewPassword')" prop="new_psd">
            <el-input
              show-password
              v-model="form.new_psd"
              @keyup.enter.native="changePassword"
              :placeholder="$t('main.pleaseEnterYourPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="is-required"
              :label="$t('main.retypePassword')"
              prop="new_confirm_psd"
          >
            <el-input
              show-password
              v-model="form.new_confirm_psd"
              @keyup.enter.native="changePassword"
              :placeholder="$t('main.PleaseConfirmYourPassword')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; margin-top: 60px;">
        <el-button class="btn" type="danger" @click="changePassword">{{
          $t('main.commit')
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { psdedit } from '@/api/index'
import Cookies from "js-cookie";
export default {
  data() {
    return {
      form: {
        old_psd: '',
        new_psd: '',
        new_confirm_psd: '',
        telephone: '',
        captcha: '',
        email: '',
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 修改密码
    changePassword() {
      let params = {
        req: {
          id: JSON.parse(Cookies.get('userinfo')).id,
          info: this.form,
        },
      }
      psdedit(params).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success',
          })
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      })
    }
  },
}
</script>

<style scoped lang="less">
.i-pwd {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;

  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;

    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }

    .tEndAdd {
      padding-right: 2.5rem;
    }
  }

  .down {
    padding: 3.75rem 5.625rem;

    .btn {
      width: 12.5rem;
      background: #635796;
      border-radius: 4px;
      border-color: #635796;
      color: #ffffff;
    }
  }
}
</style>
